import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  CardHeader,
  CardBody,
  UncontrolledAlert
} from "reactstrap";
import { MdDone, MdClear, MdArrowBack, MdUpdate } from "react-icons/md";
import { NavLink, withRouter } from "react-router-dom";
import { TextInput } from "../../Shared/Forms/TextInput";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import {
  ManageAdminDashBoard,
  AdminVerifiedDashBoard
} from "../../../_constants/RouteVariables";
import { adminDashBoardService } from "./services/adminDashBoard.service";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import TextEditor from "../../Shared/Forms/TextEditor";
import ConfirmationModal from "../../Shared/ConfirmationModal";
import { toast } from "react-toastify";

class AdminViewSpecificContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postId: null,
      postInterest: null,
      postTitle: null,
      postBody: null,
      imageUrl: null,
      data: null,
      status: null,
      canSubmit: false,
      error: null,
      formError: null,
      submitSucessful: false,
      fetching: false,
      isDeclineClick: false,
      isUpdateStatus: false,
      declineComment: null,
      postStatus: null,
      editorState: EditorState.createEmpty()
    };
  }

  routeChange = () => {
    let path = `*`;
    this.props.history.push(path);
  };
  viewValue = data => {
    const editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(data))
    );

    this.setState({ editorState });
  };

  declineConfirmation = (data, status) => {
    if (status === "update") {
      this.setState({
        declineCommit: data,
        showModal: !this.state.showModal,
        isDeclineClick: false,
        isUpdateStatus: true
      });
    } else {
      this.setState({
        declineCommit: data,
        showModal: !this.state.showModal,
        isDeclineClick: true,
        isUpdateStatus: false
      });
    }
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  componentDidMount() {
    if (this.props.location.state) {
      const { postId } = this.props.location.state;

      this.getPostsById(postId);
    }
  }

  getPostsById = id => {
    this.setState({ submitting: true });
    adminDashBoardService
      .getPost(id)
      .then(response => {
        response &&
          this.setState({
            postId: id,
            postInterest: response.interestName,
            postTitle: response.title,
            postBody: response.body,
            interestId: response.interestId,
            postStatus: response.status,
            declineComment: response.reviewerRemarks,
            imageUrl: response.imageUrl,
            formError: null,
            submitting: false,
            submitSucessful: true,
            error: null,
            fetching: false,
            isEdit: true
          });
        this.viewValue(this.state.postBody);
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  createRequest = data => {
    let requestBody = { ...data, action: 0 };
    return requestBody;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);

    this.declineConfirmation(requestBody);
  };

  handleUpdateSubmit = data => {
    this.declineConfirmation(data, "update");
  };

  declineSubmit = (data, postId) => {
    adminDashBoardService
      .reviewPost(data, postId)
      .then(response => {
        response &&
          this.setState({
            isDeclineClick: false
          });
        toast.success("Post sent for redraft successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000
        });
        this.resetForm();
        this.routeChange();
      })
      .catch(error => this.setState({ error, submitting: false }));
  };

  resetForm = () => {
    this.refs.declineForm.reset();
  };

  ClearDescription = () => {
    this.props.reset();
    this.resetForm();
  };

  stopEdit = () => {
    this.setState({
      isEdit: false
    });
  };

  showConfirmation = () => {
    this.setState({
      showModal: !this.state.showModal,
      isDeclineClick: false
    });
  };
  unApprovedPost = postId => {
    //trigger the unapproached api service here.
    adminDashBoardService
      .unApprovedPost(this.state.declineCommit, postId)
      .then(response => {
        toast.success("Post updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000
        });
        this.routeChange();
      })
      .catch(error => this.setState({ error, submitting: false }));
  };

  approvedPost = postId => {
    if (this.state.isDeclineClick) {
      this.declineSubmit(this.state.declineCommit, this.state.postId);
    } else {
      const data = {
        action: 1
      };

      adminDashBoardService
        .reviewPost(data, postId)
        .then(response => {
          toast.success("Post approved successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
          this.routeChange();
        })
        .catch(error => this.setState({ error, submitting: false }));
    }
  };

  render() {
    const {
      canSubmit,
      postId,
      postTitle,
      postBody,
      isEdit,
      isDeclineClick,
      error,
      postInterest,
      postStatus,
      imageUrl,
      declineComment,
      isUpdateStatus
    } = this.state;
    const { submitting, hasParams, selectedRow } = this.props;
    return (
      <div>
        <NavLink
          to={
            postStatus !== "PENDING"
              ? AdminVerifiedDashBoard
              : ManageAdminDashBoard
          }
        >
          <Button type="button" color="primary" className="mb-2">
            <MdArrowBack />
            <span>Back</span>
          </Button>
        </NavLink>
        {error ? (
          <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>
        ) : null}
        <Row>
          <Col sm="7" style={{ paddingTop: "1rem" }}>
            <Card>
              <Formsy>
                <TextEditor
                  name="body"
                  value={null}
                  isViewOnly={true}
                  isEdit={isEdit}
                  stopEdit={this.stopEdit}
                  postBody={postBody}
                  toolbarHidden={true}
                  postTitle={postTitle}
                  postInterest={postInterest}
                  stripPastedStyles={false}
                />
              </Formsy>
            </Card>
          </Col>

          <Col sm="5">
            <div>
              {postStatus === "PENDING" || postStatus === "APPROVED" ? (
                <Card style={{ marginTop: "1rem" }}>
                  <CardHeader>Publish</CardHeader>
                  <CardBody>
                    {error ? (
                      <UncontrolledAlert color="danger">
                        {error.message}
                      </UncontrolledAlert>
                    ) : null}

                    <Formsy
                      ref="declineForm"
                      onValidSubmit={
                        postStatus === "APPROVED"
                          ? this.handleUpdateSubmit
                          : this.handleSubmit
                      }
                      onValid={this.enableButton}
                      onInvalid={this.disableButton}
                      noValidate
                    >
                      <TextInput
                        name="remarks"
                        type="textarea"
                        value={
                          selectedRow && hasParams ? selectedRow.name : null
                        }
                        required
                        disabled={submitting}
                        title="Comment"
                        validations={{
                          minLength: 5,
                          maxLength: 250
                        }}
                        validationErrors={{
                          minLength: "Minimum of 5 characters allowed",
                          maxLength: "Maximum of 250 characters allowed"
                        }}
                      />

                      <Row>
                        {postStatus === "PENDING" ? (
                          <React.Fragment>
                            <Col sm="6">
                              <Button
                                type="button"
                                size="lg"
                                block
                                color="success"
                                className="mb-2"
                                onClick={() => this.showConfirmation()}
                                disabled={canSubmit}
                              >
                                {submitting ? (
                                  <Spinner size="sm" />
                                ) : (
                                  <span>
                                    <MdDone /> Approve
                                  </span>
                                )}
                              </Button>
                            </Col>
                            <Col sm="6">
                              <Button
                                size="lg"
                                type="submit"
                                className="mb-2"
                                color="danger"
                                block
                                disabled={!canSubmit || submitting}
                              >
                                {submitting ? (
                                  <Spinner size="sm" />
                                ) : (
                                  <span>
                                    <MdClear />
                                    Redraft
                                  </span>
                                )}
                              </Button>
                            </Col>
                          </React.Fragment>
                        ) : (
                          postStatus === "APPROVED" && (
                            <div>
                              <Col style={{ marginLeft: "5rem" }}>
                                <Button
                                  id="update"
                                  name="oo"
                                  size="lg"
                                  type="submit"
                                  className="mb-2"
                                  color="primary"
                                  block
                                  disabled={!canSubmit || submitting}
                                >
                                  {submitting ? (
                                    <Spinner size="sm" />
                                  ) : (
                                    <span>
                                      <MdUpdate /> Update
                                    </span>
                                  )}
                                </Button>
                              </Col>
                            </div>
                          )
                        )}
                      </Row>
                    </Formsy>
                  </CardBody>
                </Card>
              ) : (
                postStatus === "DECLINED" && (
                  <Card style={{ marginTop: "1rem" }}>
                    <CardHeader>Decline Comment</CardHeader>
                    <CardBody>
                      <p>{declineComment}</p>
                      <br />
                    </CardBody>
                  </Card>
                )
              )}
            </div>
            {imageUrl ? (
              <Card
                style={{
                  marginTop: "1rem",
                  width: "auto",
                  display: "inline-block"
                }}
              >
                <CardBody>
                  <img src={imageUrl} width="200" alt="" />
                </CardBody>
              </Card>
            ) : null}
          </Col>
        </Row>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={
            isUpdateStatus
              ? () => this.unApprovedPost(postId)
              : () => this.approvedPost(postId)
          }
          message={
            isDeclineClick
              ? "Do you really want to decline this post?"
              : isUpdateStatus
              ? "Do you want to update this approved post?"
              : "Do you want to approve this post?"
          }
        />
      </div>
    );
  }
}
export default withRouter(AdminViewSpecificContent);
